"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blockSlot = blockSlot;
exports.confirmSlot = confirmSlot;
exports.getBookingDetail = getBookingDetail;
exports.getPaymentOrderstatus = getPaymentOrderstatus;
exports.initiatePayment = initiatePayment;
exports.rescheduleBooking = rescheduleBooking;
exports.updateBooking = updateBooking;
exports.updatePaymentApi = updatePaymentApi;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function blockSlot(params, tokenData) {
  const apiEndPoint = _ApiConst.HOMECARE_BOOKING_API + _ApiConst.HOMECARE_BLOCK_SLOT;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getBookingDetail(id, tokenData) {
  const apiEndPoint = _ApiConst.HOMECARE_BOOKING_API + _ApiConst.HOMECARE_GET_BOOKING + '/' + id;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function confirmSlot(params, tokenData) {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.HOMECARE_CONFIRM_SLOT + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function updateBooking(params, tokenData) {
  const apiEndPoint = _ApiConst.HOMECARE_BOOKING_API + _ApiConst.HOMECARE_UPDATE_BOOKING + '/' + (params === null || params === void 0 ? void 0 : params.id);
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function initiatePayment(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params
  } = data;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.INITIATE_HOMECARE_PAYMENT_URL}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getPaymentOrderstatus(requestParams, tokenData) {
  var _requestParams$data;
  const query = (0, _utils.getQuery)(requestParams === null || requestParams === void 0 || (_requestParams$data = requestParams.data) === null || _requestParams$data === void 0 ? void 0 : _requestParams$data.params);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_HOMECARE_PAYMENT_STATUS_URL}${query}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function rescheduleBooking(params, tokenData) {
  var _params$;
  const apiEndPoint = _ApiConst.HOMECARE_BOOKING_API + _ApiConst.HOMECARE_RESCHEDULE_BOOKING + '/' + ((_params$ = params[0]) === null || _params$ === void 0 ? void 0 : _params$.id);
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function updatePaymentApi(params, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.UPDATE_PAYMENT_URL;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}